// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member-header {
  display: flex;
  flex-direction: column;
}
.member-header h1,
.member-header h4,
.member-header h5,
.member-header p {
  margin: 0;
}
.member-header .header-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.member-header .patient-notes {
  margin: 0;
  width: auto;
  background-color: #fff3c6;
  font-size: 0.875em;
  margin-right: auto;
  padding: 5px 10px;
  margin-bottom: 5px;
}
.member-header .patient-notes > button {
  margin-left: 5px;
}
.member-header .start-video-call-button {
  padding: 0;
}
.member-header .start-video-call-button.btn-tertiary {
  padding: 0;
}
.member-header .start-video-call-container {
  background: #3f8bf4;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  padding: 11px;
  margin-right: 12px;
  font-size: 18px;
}
@media screen and (max-width: 1400px) {
  .member-header .start-video-call-container {
    width: 30px;
    height: 30px;
    padding: 6px 3px;
  }
}
.member-header .video-icon {
  color: #ffffff;
}
@media screen and (max-width: 1400px) {
  .member-header .video-icon {
    width: 20px;
    height: 20px;
  }
}
@media screen and (max-width: 1400px) {
  .member-header .video-chat-text {
    font-size: 10px;
  }
}
.member-header .patient-info {
  display: flex;
  flex-direction: column;
  padding: 5px 0;
}
.member-header .patient-info .subtitle {
  display: flex;
  justify-content: flex-start;
  color: #444444;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 12px;
}
.member-header .patient-info .subtitle .patient-status {
  font-weight: bold;
}
.member-header .patient-info .subtitle > span {
  padding-left: 15px;
  align-self: center;
}
.member-header .patient-alerts-conditions-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.member-header .patient-alerts {
  display: flex;
}
.member-header .patient-alerts .alert-count {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border-radius: 50%;
  text-align: center;
  padding: 10px;
  height: 65px;
  min-width: 65px;
  white-space: nowrap;
}
.member-header .patient-alerts .alert-count h5 {
  letter-spacing: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/MemberProfile/Header/main.less"],"names":[],"mappings":"AAEA;EAOE,aAAA;EACA,sBAAA;AAPF;AADA;;;;EAKI,SAAA;AAEJ;AAPA;EAWI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AADJ;AAbA;EAkBI,SAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;AAtBA;EA2BM,gBAAA;AAFN;AAzBA;EAgCI,UAAA;AAJJ;AAMI;EACE,UAAA;AAJN;AA/BA;EAwCI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AANJ;AAOI;EAAA;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EAJJ;AACF;AA/CA;EAuDI,cAAA;AALJ;AAMI;EAAA;IACE,WAAA;IACA,YAAA;EAHJ;AACF;AAOI;EAAA;IACE,eAAA;EAJJ;AACF;AA7DA;EAqEI,aAAA;EACA,sBAAA;EACA,cAAA;AALJ;AAlEA;EAyEM,aAAA;EACA,2BAAA;EACA,cAAA;EACA,2CAAA;EACA,eAAA;AAJN;AAzEA;EAgFQ,iBAAA;AAJR;AA5EA;EAoFQ,kBAAA;EACA,kBAAA;AALR;AAhFA;EA2FI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AARJ;AAtFA;EAkGI,aAAA;AATJ;AAzFA;EAqGM,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AATN;AAvGA;EAmHQ,iBAAA;AATR","sourcesContent":["@import (reference) '~styleguide/src/styles/variables.less';\n\n.member-header {\n  h1,\n  h4,\n  h5,\n  p {\n    margin: 0;\n  }\n  display: flex;\n  flex-direction: column;\n\n  .header-wrapper {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .patient-notes {\n    margin: 0;\n    width: auto;\n    background-color: #fff3c6;\n    font-size: 0.875em;\n    margin-right: auto;\n    padding: 5px 10px;\n    margin-bottom: 5px;\n\n    > button {\n      margin-left: 5px;\n    }\n  }\n\n  .start-video-call-button {\n    padding: 0;\n\n    &.btn-tertiary {\n      padding: 0;\n    }\n  }\n\n  .start-video-call-container {\n    background: @btnBlue;\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n    padding: 11px;\n    margin-right: 12px;\n    font-size: 18px;\n    @media screen and (max-width: 1400px) {\n      width: 30px;\n      height: 30px;\n      padding: 6px 3px;\n    }\n  }\n\n  .video-icon {\n    color: @white;\n    @media screen and (max-width: 1400px) {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .video-chat-text {\n    @media screen and (max-width: 1400px) {\n      font-size: 10px;\n    }\n  }\n\n  .patient-info {\n    display: flex;\n    flex-direction: column;\n    padding: 5px 0;\n    .subtitle {\n      display: flex;\n      justify-content: flex-start;\n      color: @textBlack;\n      font-family: @font-family-roboto-condensed;\n      font-size: 12px;\n\n      .patient-status {\n        font-weight: bold;\n      }\n\n      > span {\n        padding-left: 15px;\n        align-self: center;\n      }\n    }\n  }\n\n  .patient-alerts-conditions-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .patient-alerts {\n    display: flex;\n\n    .alert-count {\n      display: flex;\n      flex-direction: column;\n      align-content: center;\n      align-items: center;\n      justify-content: center;\n      background-color: @white;\n      border-radius: 50%;\n      text-align: center;\n      padding: 10px;\n      height: 65px;\n      min-width: 65px;\n      white-space: nowrap;\n\n      h5 {\n        letter-spacing: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
